import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { TableToolbar, TableToolbarContent, TableToolbarSearch, Checkbox, TableToolbarMenu, Button, TooltipDefinition } from 'carbon-components-react'
import { FilterEdit32, DotMark32 } from '@carbon/icons-react';

import { ReactComponent as NewTab } from '../../assets/NewTab.svg'
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import TableToolbarDownload from '../../common/TableToolbarDownload';
import * as queueStatus from './QueueAlertsMockData';
import Filters from './Alerts/Filters';
import TableWithExpandedRowList from '../../common/ExpandedTable';
import callPostApi from "../../requests/PostRequests";
import * as Constants from '../../requests/URLConstants'
import * as DashboardUtils from '../Dashboards/DashboardUtils'
import * as workspaces from '../../config/WorkspaceConstants'
import "./queue-alerts.scss";

export default function QueueAlerts(props) {

    const [showFilters, setShowFilters] = useState(false);
    const [filteredTableHeaders, setFilteredTableHeaders] = useState([]);
    const [searchedQueueData, setSearchedQueueData] = useState([]);
    const [QueueDataLoading, setQueueDataLoading] = useState(false);
    const [QueueStatusData, setQueueStatusData] = useState([]);
    const [searchedValue, setSearchedValue] = useState('');
    const [headers, setHeaders] = useState(queueStatus.queueStatusHeaders);
    //const [DotValue, setDotValue] = useState();

    useEffect(() => {
        getQueueAlerts(props.timeFilterSelections, props.filterSelections);
    }, [props.timeFilterSelections, props.filterSelections]);



    function getTimeDifference(seconds) {
        seconds = Number(seconds);
        var days = Math.floor(seconds / (3600 * 24));
        var hours = Math.floor((seconds % (3600 * 24)) / 3600);
        var minutes = Math.floor((seconds % 3600) / 60);

        var dayDisplay = days > 0 ? days + (days === 1 ? " day " : " days ") : "";
        var hourDisplay = hours > 0 ? hours + (hours === 1 ? " hr " : " hrs ") : "";
        var minuteDisplay = minutes > 0 ? minutes + (minutes === 1 ? " min " : " mins ") : "";
        return seconds > 59 ? dayDisplay + hourDisplay + minuteDisplay : "0 min";
    }

    const getQueueAlerts = (timeFilterSelections, filterSelections) => {
        setQueueDataLoading(true);
        let formattedData = [];
        let franchise;
        let client;
        let technology; let geo; let deployment; let automataState; let automataName; let competency; let botId; let priority; let status;
        console.log(filterSelections, "filter");
        if (filterSelections != null && filterSelections.franchise != null && filterSelections.franchise.length > 0) {
            franchise = filterSelections.franchise;

        }

        if (filterSelections != null && filterSelections.client != null && filterSelections.client.length > 0) {
            client = filterSelections.client;
        }
        if (filterSelections != null && filterSelections.technology != null && filterSelections.technology.length > 0) {
            technology = filterSelections.technology;
        }
        if (filterSelections != null && filterSelections.deployment_model != null && filterSelections.deployment_model.length > 0) {
            deployment = filterSelections.deployment_model;
        }
        if (filterSelections != null && filterSelections.geo != null && filterSelections.geo.length > 0) {
            geo = filterSelections.geo;
        }
        if (filterSelections != null && filterSelections.competency != null && filterSelections.competency.length > 0) {
            competency = filterSelections.competency;
        }
        if (filterSelections != null && filterSelections.automata_state != null && filterSelections.automata_state.length > 0) {
            automataState = filterSelections.automata_state;
        }
        if (filterSelections != null && filterSelections.bot_id != null && filterSelections.bot_id.length > 0) {
            botId = filterSelections.bot_id;
        }
        if (filterSelections != null && filterSelections.automata_activity_name != null && filterSelections.automata_activity_name.length > 0) {
            automataName = filterSelections.automata_activity_name;
        }
        if (filterSelections != null && filterSelections.priority != null && filterSelections.priority.length > 0) {
            priority = filterSelections.priority;
        }
        if (filterSelections != null && filterSelections.status != null && filterSelections.status.length > 0) {
            status = filterSelections.status;
        }

        let bodyJSON = {
            filters: {
                time: {
                    startDateTime: timeFilterSelections.startDateTime,
                    endDateTime: timeFilterSelections.endDateTime
                },
                franchises: franchise,
                clients: client,
                technologies: technology,
                deployment_models: deployment,
                geos: geo,
                business_competencies: competency,
                automata_state: automataState,
                automata_name: automataName,
                bot_id: botId,
                // priority: priority,
                //status: status
            }
        }
        callPostApi(Constants.GETQUEUESTATUS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareQueueAlertsData(resp);
                setQueueStatusData(formattedData.tableData);
                setQueueDataLoading(false);
            }).catch((error) => {
                setQueueDataLoading(false);
            });
    }

    const determinefillColor = (status) => {
        if (status === "Missing" || status === "missing" || status === "Offline" || status === "offline") {
            //red
            return '#FA4D56';
        }
        else if (status === null || status === undefined) {
            //grey
            return "#C6C6C6";
        }
        else //green
            return "#6FDC8C";
    }

    const openTicketingTool = (url) => {
        window.open(url, "_blank");
    };

    const prepareQueueAlertsData = (response) => {
        let tableData = [];
        let tableObj = {};
        if (response) {
            for (let i = 0; i < response.length; i++) {
                let expandedObj = {};
                let expandedData = [];
                let offset = moment(response[i].recentTimeProcessedAt).utcOffset();
                let recentTimeProcessedAt = moment.utc(response[i].recentTimeProcessedAt).utcOffset(offset).format();
                let seconds = moment().diff(recentTimeProcessedAt, "seconds");
                let timeSpanLastProcesses = getTimeDifference(seconds);

                tableObj = {
                    id: (i + 1).toString(),
                    automataName: response[i].automataName,
                    queueName: response[i].queueName,
                    totalItem: response[i].totalItem,
                    pending: response[i].pending,
                    running: response[i].running,
                    completed: response[i].completed,
                    businessException: response[i].businessException,
                    systemExecption: response[i].systemExecption,
                    deferred: response[i].deferred,
                    recentTimeProcessedAt: moment.utc(response[i].recentTimeProcessedAt).utcOffset(offset).format('YYYY-MM-DD HH:mm:ss'),
                    timeSpanLastProcesses: timeSpanLastProcesses
                }
                for (let j = 0; j < response[i].resources.length; j++) {
                    let fillColor = determinefillColor(response[i].resources[j].status);
                    let ticketingToolPath = response[i].resources[j].incidentUrl;
                    let offset = moment(response[i].resources[j].recentTimeProcessedAt).utcOffset();
                    let ResourceRecentTimeProcessedAt = moment.utc(response[i].resources[j].recentTimeProcessedAt).utcOffset(offset).format("YYYY-MM-DD HH:mm:ss");
                    let ResourceSeconds = moment().diff(ResourceRecentTimeProcessedAt, "seconds");
                    let ResourcetimeSpanLastProcesses = getTimeDifference(ResourceSeconds);
                    expandedObj = {
                        id: (j + 1).toString(),
                        automataName:
                            <div className='dot-container'>
                                {/* <TooltipDefinition
                                    direction="right"
                                    alignment="left"
                                    tooltipText={response[i].resources[j].dotValue !== null && response[i].resources[j].dotValue !== undefined ?
                                        <div>{response[i].resources[j].dotValue}</div>
                                        : "No value"} > */}
                                <DotMark32 style={{ fill: fillColor }} />
                                {/* </TooltipDefinition> */}
                                <div className='resource-name'> {response[i].resources[j].name}</div> <div className='incident-number'>{response[i].resources[j].incidentId} </div>
                                {ticketingToolPath && <NewTab className="new-tab" onClick={() => openTicketingTool(ticketingToolPath)} />}
                            </div>,
                        status: response[i].resources[j].status,
                        queueName: response[i].resources[j].queueName,
                        totalItem: response[i].resources[j].totalItem,
                        pending: response[i].resources[j].pending,
                        running: response[i].resources[j].running,
                        completed: response[i].resources[j].completed,
                        businessException: response[i].resources[j].businessException,
                        systemExecption: response[i].resources[j].systemExecption,
                        deferred: response[i].resources[j].deferred,
                        recentTimeProcessedAt: moment.utc(response[i].resources[j].recentTimeProcessedAt).utcOffset(offset).format("YYYY-MM-DD HH:mm:ss"),
                        timeSpanceLastProcesses: ResourcetimeSpanLastProcesses
                    }
                    expandedData.push(expandedObj);
                    tableObj.expandedItems = expandedData;
                }
                tableData.push(tableObj);
            }
        }
        tableData.sort((a, b) => (new Date(a.recentTimeProcessedAt).getTime() || -Infinity) - (new Date(b.recentTimeProcessedAt).getTime() || -Infinity)).reverse();
        return { tableData };
    };

    const manageHeader = (checked, id) => {
        headers.forEach(header => {
            if (header.key === id) {
                header.hidden = !checked;
            }
        });
        let filteredheader = headers.filter(header => header.hidden === false);
        setFilteredTableHeaders(filteredheader);
    };

    const searchTable = (event) => {
        let searchString = event.target.value.toUpperCase();
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            newList = QueueStatusData.filter((element) => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        if (element[property] && property !== "id") {
                            string = element[property];
                        }
                        else string = '';
                        string = string ? string.toString() : "";
                        pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            newList = newList.concat([element]);
                            return newList;
                        }
                    }
                }
            });
            setSearchedQueueData(newList);

        } else {
            setSearchedQueueData([]);
        }
    };

    const handleFilters = () => {
        setShowFilters(!showFilters);
    }

    const handleClose = () => {
        setShowFilters(!showFilters);
    }

    return (
        <div className="queue-status-tab manage-automation-page__r3 dashboard-charts-container">
            <section className="border-bottom queue-metrics">
                <div className="graph-title">
                    <div className="title carbon-display-Regular-20">{DashboardConstants.QueueStatus}</div>
                    <div className="table-toolbar">
                        <TableToolbar aria-label="data table toolbar">
                            <TableToolbarContent style={{ clipPath: 'none', zIndex: 1 }}>
                                <TableToolbarSearch onChange={(e) => { setSearchedValue(e.target.value); searchTable(e) }} className="search-button" />
                                {/* <TableToolbarMenu light iconDescription="Headers">
                                    <fieldset className="optional-headers">
                                        {headers.map(header => (header.optional ? <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageHeader} id={header.key} /> : null))}
                                    </fieldset>
                                </TableToolbarMenu> */}
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={QueueStatusData} headers={headers} title={props.title} filename={'fileName'} label="Download" />
                                <Button onClick={handleFilters} renderIcon={FilterEdit32}>{DashboardConstants.Filters}</Button>
                            </TableToolbarContent>
                        </TableToolbar>
                        {showFilters ?
                            <div>
                                <Filters workspace={props.workspace} alertType={props.alertType} filterData={props.filterData} filterSelections={props.filterSelections} status={props.status}
                                    disabledSelects={props.disabledSelects} handleClose={handleClose} fetchAlertsData={props.fetchAlertsData} updateState={props.updateState} isResourceType={false}
                                    isQueueType={true}
                                />
                            </div> : null
                        }
                    </div>
                </div>
                <div>
                    <TableWithExpandedRowList
                        loading={QueueDataLoading}
                        rows={searchedValue.length ? searchedQueueData : QueueStatusData}
                        expandedheaders={queueStatus.queueStatusExpandedHeaders}
                        headers={filteredTableHeaders.length ? filteredTableHeaders : headers.filter(header => header.hidden === false)}
                        showPagination={true} isSortable={true} isExpandable={true}
                        defaultCurrentPageSize={10}
                    />
                </div>
            </section>
        </div>
    )

}